<template>
  <div class="footprint-page">
    <!-- <Top></Top> -->
    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 页面标题 -->
      <div class="page-title">
        <i class="icon-footprint"></i>
        <span>我的足迹</span>
      </div>

      <!-- 左右布局 -->
      <div class="layout">
        <!-- 左侧时间筛选 -->
        <aside class="left-sidebar">
          <button class="time-btn active">今天</button>
          <button class="time-btn">近一个月</button>
        </aside>

        <!-- 右侧模型列表 -->
        <section class="right-content">
          <!-- 今天的足迹 -->
          <div class="footprint-group">
            <div class="group-header">
              <span class="date">2025-10-29</span>
            </div>
            <div class="model-grid">
              <div class="model-card" v-for="(item, index) in todayModels" :key="index">
                <img v-watermark="{
                                text: '智步模型交易网',
                                fontSize: 16,
                                color: '	rgba(150, 150, 150, 0.25)',
                                enabled: watermarkEnabled
                            }" :src="item.img" alt="模型图片" class="model-img">
                <div class="model-info">
                  <span class="model-tag">{{ item.tag }}</span>
                  <span class="model-name">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 近一个月的足迹 -->
          <div class="footprint-group">
            <div class="group-header">
              <span class="date">2025-10-22</span>
            </div>
            <div class="model-grid">
              <div class="model-card" v-for="(item, index) in monthModels" :key="index">
                <img v-watermark="{
                                text: '智步模型交易网',
                                fontSize: 16,
                                color: '	rgba(150, 150, 150, 0.25)',
                                enabled: watermarkEnabled
                            }" :src="item.img" alt="模型图片" class="model-img">
                <div class="model-info">
                  <span class="model-tag">{{ item.tag }}</span>
                  <span class="model-name">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- 右侧固定功能栏 -->
    <!-- <Bottom></Bottom> -->
  </div>
</template>
<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';
export default {
  name: 'Dashboard',
  components: { Top, Bottom },
  data() {
    return {
      todayModels: [
        { img: 'https://picsum.photos/seed/footprint1/200/150', tag: '模型', name: '写实雪景' },
        { img: 'https://picsum.photos/seed/footprint2/200/150', tag: '模型', name: 'Archmodels_vol.026_c...' },
        { img: 'https://picsum.photos/seed/footprint3/200/150', tag: '作品', name: '唐代十二生肖陶俑' },
        { img: 'https://picsum.photos/seed/footprint4/200/150', tag: '作品', name: 'UE5 最后生还者 游戏风格...' }
      ],
      monthModels: [
        { img: 'https://picsum.photos/seed/footprint5/200/150', tag: '模型', name: '大同华严寺 华严寺大雄宝...' },
        { img: 'https://picsum.photos/seed/footprint6/200/150', tag: '模型', name: '写实雪景' },
        { img: 'https://picsum.photos/seed/footprint7/200/150', tag: '模型', name: '北方古建 歇山 重檐歇山顶...' },
        { img: 'https://picsum.photos/seed/footprint8/200/150', tag: '模型', name: 'UE5万里长城雪景雨景日...' },
        { img: 'https://picsum.photos/seed/footprint9/200/150', tag: '模型', name: '写实窑洞 窑洞大门 土窑3...' },
        { img: 'https://picsum.photos/seed/footprint10/200/150', tag: '模型', name: '炮台-碉堡-烽火台-城门楼...' }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
// 全局颜色变量
@red-primary: #C62828;
@bg-dark: #212121;
@bg-card: #333;
@text-primary: #E0E0E0;
@text-secondary: #BDBDBD;
@border-color: #444;

.footprint-page {
  min-width: 1905px;
  background-color: @bg-dark;
  color: @text-primary;
  min-height: 100vh;
  font-family: "Microsoft YaHei", sans-serif;
}

// 主体内容
.main-content {
  padding: 0 300px;

  .page-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-left: 10px;

    .icon-footprint {
      width: 24px;
      height: 24px;
      background-color: #2196F3;
      border-radius: 10%;
      display: inline-block;
      margin-right: 10px;
    }

    span {
      font-size: 20px;
    }
  }

  .layout {
    display: flex;
    gap: 20px;

    .left-sidebar {
      width: 200px;

      .time-btn {
        display: block;
        width: 100%;
        padding: 12px;
        background-color: @bg-card;
        border: 1px solid @border-color;
        color: @text-primary;
        text-align: left;
        cursor: pointer;
        margin-bottom: 10px;
        border-radius: 4px;

        &.active {
          background-color: #2196F3;
          color: #FFF;
        }

        &:hover:not(.active) {
          background-color: #444;
        }
      }
    }

    .right-content {
      flex: 1;

      .footprint-group {
        margin-bottom: 30px;

        .group-header {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          padding-bottom: 5px;
          border-bottom: 1px solid @border-color;

          .date {
            color: @text-secondary;
            font-size: 14px;
          }
        }

        .model-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
        }

        .model-card {
          background-color: @bg-card;
          border-radius: 4px;
          overflow: hidden;
          transition: transform 0.2s;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          }

          .model-img {
            width: 100%;
            height: 150px;
            object-fit: cover;
          }

          .model-info {
            padding: 10px;

            .model-tag {
              background-color: #FF9800;
              color: #FFF;
              font-size: 12px;
              padding: 2px 6px;
              border-radius: 4px;
              margin-right: 8px;
            }

            .model-name {
              color: @text-secondary;
              font-size: 13px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}

// 右侧固定功能栏
.fixed-sidebar {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;

  .fixed-btn {
    background-color: #2196F3;
    color: #FFF;
    border: none;
    width: 50px;
    height: 50px;
    margin-bottom: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    i {
      width: 20px;
      height: 20px;
      margin-bottom: 3px;
      display: inline-block;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 3px;
    }

    &:hover {
      background-color: #1976D2;
    }
  }
}
</style>